export default 'assets/095f102ecf67d3a4185a1b155b1b7105.png';